import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
// MUI
import { AppBar, Tabs, Tab } from "@mui/material";
import PropTypes from "prop-types";
// Components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";

// Thunks
import {
  createPptContent,
  getAllmasterModulesAPI,
  getAllPptContentAPI,
  getAllsubmodulesAPI,
  getAllTopicsAPI,
  updatePptContent,
  createQuizContent,
} from "./Pptactivity.Thunk";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { purple } from "@mui/material/colors";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// swal
import Swal from "sweetalert2";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

function PptActivityPage() {
  // For tabs start

  const [tabIndex, setTabIndex] = useState(0);

  const onTabChange = (event, index) => {
    setTabIndex(index);
  };

  const onTabIndexChange = (index) => {
    setTabIndex(index);
  };

  // For tabs end
  const navigate = useNavigate();
  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [preferedlanguage, setPreferedlanguage] = useState("");
  const [selModuleDetails, setSelModuleDetails] = useState("");
  const [selSubModuleDetails, setSelSubModuleDetails] = useState("");
  const [selTopicDetails, setSelTopicDetails] = useState("");
  const [usertype, setUsertype] = useState("");
  const [modules, setModules] = useState([]);
  const [subModules, setSubModules] = useState([]);
  const [topics, setTopics] = useState([]);
  const [contents, setContents] = useState([]);
  //console.log(" contentshow------->", contents.length);
  //console.log(" contentshow2------->", contents);
  const [quiz, setQuizs] = useState([]);
  // //console.log("quizbutton show------->", quiz);
  const [Module_id, setModule_id] = useState();
  const [disable_content_button, setDisable_content_button] = useState(true);
  const [contentDetails, setContentDetails] = useState([]);
  const [showQuizButton, setShowQuizButton] = useState(true);

  const [quizQuestion, setQuizQuestion] = useState("");
  const [optionA, setOptionA] = useState("");
  const [optionB, setOptionB] = useState("");
  const [optionC, setOptionC] = useState("");
  const [optionD, setOptionD] = useState("");
  const [quizAns, setQuizAns] = useState("");

  const quiz_question_select_onchange = (event) => {
    setQuizQuestion(event.target.value);
  };

  const quiz_optA_select_onchange = (event) => {
    setOptionA(event.target.value);
  };

  const quiz_optB_select_onchange = (event) => {
    setOptionB(event.target.value);
  };

  const quiz_optC_select_onchange = (event) => {
    setOptionC(event.target.value);
  };

  const quiz_optD_select_onchange = (event) => {
    setOptionD(event.target.value);
  };

  const quiz_ans_select_onchange = (event) => {
    setQuizAns(event.target.value);
  };

  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);

  // -------------- Preview -----------------------
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContenttitle, setPreviewContenttitle] = useState("");
  const [previewContent, setPreviewContent] = useState("");

  const contentOnClick = (segment) => {
    setPreviewContenttitle(segment.topicname);
    setPreviewContent(segment.contentData);
    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };

  // ----------- create, update delete button click ----------
  const create_content_button_click = () => {
    setOperation("save");
    setContenttitle("");
    setContentduration(0);
    setContent("");
    setIndex(-1);
    //setOpenEditor(true);
    {
      contents[0].contentData && contents[0].contentData.length > 0
        ? alert("Content already Created")
        : setOpenEditor(true);
    }
    // {
    //   contents.length > 0
    //     ? alert("Content already Created")
    //     : setOpenEditor(true);
    // }
  };

  //on update
  const update_content_button_click = (eachsegment, index) => {
    // //console.log(eachsegment, Module_id, "eachsegmentjkksd");
    handleVertMenuClose();
    setOperation("update");
    setContenttitle(eachsegment.topicname);
    setContentduration(eachsegment.duration);
    setContent(eachsegment.contentData);
    setContentid(eachsegment.topicid);
    setIndex(index);
    setOpenEditor(true);
  };
  //on Delete
  const delete_content_button_click = (eachsegment, index) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const update_content = [];
        const data = {
          usertype: eachsegment.usertype,
          trainingType: eachsegment.trainingType,
          topicid: eachsegment.topicid,
          contentData: [],
        };
        // //console.log(data);
        updatePptContent(data).then((response) => {
          // //console.log(response.data);
          if (response.data.status === "success") {
            const data = {
              usertype: usertype,
              trainingType: "ppt",
              moduleid: selModuleDetails.moduleid,
              submoduleid: selSubModuleDetails.submoduleid,
              topicid: eachsegment.topicid,
              // language: preferedlanguage,
            };

            getAllPptContentAPI(data).then((content) => {
              // //console.log(content, "content");
              if (content.data.length > 0) {
                setContents(content.data);
                setQuizs(content.data[0].quizData);
                setModule_id(content.data[0]._id);
                setContentDetails(content.data);
              }
            });
          }
        });
      }
    });
  };
  // -------------- Editor -----------------------

  const [openEditor, setOpenEditor] = useState(false);
  const [operation, setOperation] = useState("");
  const [contenttitle, setContenttitle] = useState("");
  const [contentduration, setContentduration] = useState(0);
  const [content, setContent] = useState("");
  const [contentid, setContentid] = useState();
  const [contenttype, setContenttype] = useState("content");
  const [index, setIndex] = useState(-1);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseEditor = () => {
    setOpenEditor(false);
  };

  const handleVertMenuClick = (event, eachsegment, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setSelectedSegment(eachsegment);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedSegment({});
  };

  const saveEditorContentData = (editor_data) => {
    // contents

    setOpenEditor(false);
    if (editor_data.operation === "update") {
      if (editor_data.content.length > 2) {
        const update_content = [
          {
            contentid: contentid,
            content: editor_data.content,
            type: contenttype,
          },
        ];
        const data = {
          usertype: usertype,
          trainingtype: "ppt",

          contentData: editor_data.content,

          topicid: contentDetails[0].topicid,
        };
        // //console.log(data);
        updatePptContent(data).then((response) => {
          // //console.log(response.data);
          if (response.data.status === "success") {
            const data = {
              usertype: usertype,
              trainingType: "ppt",
              moduleid: selModuleDetails.moduleid,
              submoduleid: selSubModuleDetails.submoduleid,
              topicid: contentDetails[0].topicid,
              // language: preferedlanguage,
            };

            getAllPptContentAPI(data).then((content) => {
              // //console.log(content, "content");
              if (content.data.length > 0) {
                setContents(content.data);
                setQuizs(content.data[0].quizData);
                setModule_id(content.data[0]._id);
                setContentDetails(content.data);
                toast.success("Changes made successfully");
              }
            });
          }
        });
        // https://thinkzone.in.net/thinkzone/ppt_deletecontent/6218c8c514d0141fe03a401f
      } else {
        toast.error("Enter some contents to save");
      }
    } else if (editor_data.operation === "save") {
      // //console.log(contentDetails, "contentDetails", editor_data, "editor_data");
      if (contentDetails.length > 0) {
        const content = [
          {
            contentid: new Date().getTime(),
            content: editor_data.content,
            type: contenttype,
          },
        ];
        const save_data = {
          usertype: usertype,
          trainingtype: "ppt",

          contentData: editor_data.content,

          topicid: contentDetails[0].topicid,
        };

        // //console.log(save_data, "save_data");
        updatePptContent(save_data).then((response) => {
          // //console.log(response.data);
          if (response.data.status === "success") {
            const data = {
              usertype: usertype,
              trainingType: "ppt",
              moduleid: selModuleDetails.moduleid,
              submoduleid: selSubModuleDetails.submoduleid,
              topicid: contentDetails[0].topicid,
              // language: preferedlanguage,
            };

            getAllPptContentAPI(data).then((content) => {
              // //console.log(content, "content");
              if (content.data.length > 0) {
                setContents(content.data);
                setQuizs(content.data[0].quizData);
                setModule_id(content.data[0]._id);
                setContentDetails(content.data);
                toast.success("Changes made successfully");
              }
            });
          }
        });
      } else {
        const new_Content = [
          {
            contentid: new Date().getTime(),
            content: editor_data.content,
            type: contenttype,
          },
        ];
        // //console.log(selSubModuleDetails, "selSubModuleDetails");
        const save_data = {
          // content: new_Content,
          usertype: usertype,
          trainingtype: "ppt",
          contentData: editor_data.content,
          topicid: selTopicDetails.topicid,
        };

        // //console.log(save_data, "save_data");
        createPptContent(save_data).then((response) => {
          // //console.log(response.data);
          if (response.data.status === "success") {
            const data = {
              usertype: usertype,
              trainingType: "ppt",
              moduleid: selModuleDetails.moduleid,
              submoduleid: selSubModuleDetails.submoduleid,
              topicid: selTopicDetails.topicid,
              // language: preferedlanguage,
            };

            getAllPptContentAPI(data).then((content) => {
              // //console.log(content, "content");
              if (content.data.length > 0) {
                setContents(content.data);
                setQuizs(content.data[0].quizData);
                setModule_id(content.data[0]._id);
                setContentDetails(content.data);
                toast.success("Changes made successfully");
              }
            });
          }
        });
      }
    }
  };

  //---------------create quiz----------------------//

  const create_quiz_button_click = () => {
    setShowUpdate(true);
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };
  const [questionId, setQuestionId] = useState("");

  const handleQuizSaveChanges = (editor_data) => {
    setShowUpdate(false);
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setQuizQuestion("");
    setQuizAns("");
    // const new_Content = [
    //   {
    //     contentid: new Date().getTime(),
    //     content: editor_data.content,
    //     type: contenttype,
    //   },
    // ];
    if (operation === "update") {
      // //console.log(operation);
      // //console.log(
      //   quizQuestion,
      //   optionA,
      //   optionB,
      //   optionC,
      //   optionD,
      //   quizAns,
      //   questionId,
      //   "quizAns"
      // );
      const res = quiz.map((item) => {
        // //console.log(item);
        if (item.qid == questionId) {
          item.A = optionA;
          item.B = optionB;
          item.C = optionC;
          item.D = optionD;
          item.answer = quizAns;
          item.question = quizQuestion;
        }
      });
      // //console.log(quiz, "res");

      const data = {
        usertype: usertype,
        trainingType: "ppt",
        topicid: contentDetails[0].topicid,
        quizData: quiz,
      };
      // //console.log("ppt data--->", data);
      updatePptContent(data).then((response) => {
        // //console.log(response.data, "create training------------------->");
        if (response.data.status === "success") {
          const data = {
            usertype: usertype,
            moduleid: selModuleDetails.moduleid,
            submoduleid: selSubModuleDetails.submoduleid,
            topicid: selTopicDetails.topicid,
            language: preferedlanguage,
          };
          getAllPptContentAPI(data).then((content) => {
            // //console.log(content, "content");
            if (content.data.length > 0) {
              setContents(content.data);
              setQuizs(content.data[0].quizData);
              setModule_id(content.data[0]._id);
              setContentDetails(content.data);
              toast.success("Changes made successfully");
            }
          });
        }
      });
    } else {
      const data = {
        usertype: usertype,
        trainingType: "ppt",
        topicid: selTopicDetails.topicid,
        quizData: [
          ...contents[0].quizData,
          {
            A: optionA,
            B: optionB,
            C: optionC,
            D: optionD,
            answer: quizAns,
            qid: new Date().getTime(),
            question: quizQuestion,
          },
        ],
      };

      // //console.log("create quiz------>", data);

      createQuizContent(data).then((element) => {
        // //console.log("setquiz--->", element.data);

        if (element.data.status === "success") {
          const data = {
            usertype: usertype,
            trainingType: "ppt",
            moduleid: selModuleDetails.moduleid,
            submoduleid: selSubModuleDetails.submoduleid,
            topicid: selTopicDetails.topicid,
            language: preferedlanguage,
            // usertype: usertype,
            // trainingType: "ppt",
          };

          getAllPptContentAPI(data).then((content) => {
            // //console.log(content, "content");
            if (content.data.length > 0) {
              setContents(content.data);
              setQuizs(content.data[0].quizData);
              setModule_id(content.data[0]._id);
              setContentDetails(content.data);
              toast.success("Changes made successfully");
            }
          });
        }
      });
    }
  };

  //on update
  const update_quiz_button_click = (eachsegment, index) => {
    // //console.log(eachsegment, Module_id, "eachsegmentjkksd");
    handleVertMenuClose();
    setOperation("update");
    // setContenttitle(eachsegment.displayname);
    // setContent(eachsegment.content);
    // setContentid(eachsegment.contentid);
    setQuizAns(eachsegment.answer);
    setOptionA(eachsegment.A);
    setOptionB(eachsegment.B);
    setOptionC(eachsegment.C);
    setOptionD(eachsegment.D);
    setQuizQuestion(eachsegment.question);
    setIndex(index);
    // setOpenEditor(true);
    setQuestionId(eachsegment.qid);
    setShowUpdate(true);
  };
  //on Delete
  const delete_quiz_button_click = (eachsegment, index) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const qz = quiz.filter((item) => item.qid !== eachsegment.qid);

        // //console.log(eachsegment, "delete data");
        // //console.log(quiz, "res");
        // //console.log(
        //   quiz.filter((item) => item.qid !== eachsegment.qid),
        //   "checkkkk---->"
        // );
        const data = {
          usertype: usertype,
          trainingType: "ppt",
          topicid: contentDetails[0].topicid,
          quizData: qz,
        };
        // //console.log("ppt data--->", data);
        updatePptContent(data).then((response) => {
          // //console.log(response.data, "create training------------------->");
          if (response.data.status === "success") {
            const data = {
              usertype: usertype,
              trainingType: "ppt",
              moduleid: selModuleDetails.moduleid,
              submoduleid: selSubModuleDetails.submoduleid,
              topicid: selTopicDetails.topicid,
              language: preferedlanguage,
            };
            // //console.log("data--->", data);
            getAllPptContentAPI(data).then((content) => {
              // //console.log(content, "content");
              // if (content.data.length > 0) {
              //setContents(content.data);
              setQuizs(content.data[0].quizData);
              // setModule_id(content.data[0]._id);
              // setContentDetails(content.data);
              toast.success("Changes made successfully");
              // }
            });
          }
        });
      }
    });
  };

  //-------------------create quiz end -----------------------//

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/pptmodules&submodules"); //
  };
  const navigate_too = () => {
    navigate("/user-assignment");
  };

  //on language change
  const preflanguage_select_onchange = (e) => {
    setPreferedlanguage(e.target.value);
    //console.log("Language--------->", preferedlanguage);
  };

  //on usertype change
  const usertype_select_onchange = (e) => {
    setUsertype(e.target.value);
    const data = {
      usertype: e.target.value,
      language: preferedlanguage,
    };
    getAllmasterModulesAPI(data).then((modules) => {
      // //console.log(modules.data, "modules");
      setModules(modules.data);
    });
  };

  //on module change
  const module_select_onchange = (e) => {
    // //console.log(e.target.value, "module on change");
    const data = {
      usertype: usertype,
      language: preferedlanguage,
      moduleid: e.target.value.moduleid,
    };
    setSelModuleDetails(e.target.value);
    getAllsubmodulesAPI(data).then((submodules) => {
      // //console.log(submodules.data, "modules");
      setSubModules(submodules.data);
    });
  };

  //on subModule Change
  const submodule_select_onchange = (e) => {
    // //console.log(e.target.value, "");
    const data = {
      usertype: usertype,
      language: preferedlanguage,
      moduleid: selModuleDetails.moduleid,
      submoduleid: e.target.value.submoduleid,
      // language: preferedlanguage,
    };
    setSelSubModuleDetails(e.target.value);
    getAllTopicsAPI(data).then((topic) => {
      setTopics(topic.data);
    });
  };
  //on topic change
  const topic_select_onchange = (e) => {
    setSelTopicDetails(e.target.value); //
    setDisable_content_button(false);
    setShowQuizButton(false);
    const data = {
      usertype: usertype,
      trainingType: "ppt",
      moduleid: selModuleDetails.moduleid,
      submoduleid: selSubModuleDetails.submoduleid,
      topicid: e.target.value.topicid,
      // language: preferedlanguage,
    };

    getAllPptContentAPI(data).then((content) => {
      // //console.log(content, "content");
      if (content.data.length > 0) {
        setContents(content.data);
        setQuizs(content.data[0].quizData);
        setModule_id(content.data[0]._id);
        setContentDetails(content.data);
      }
    });
  };
  return (
    <>
      <div>
        <MuiHeader header="PPT MODULE" />
        <FormControl
          sx={{ m: 1 }}
          style={{ marginTop: 73, width: "130px" }}
          size="small"
        >
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={preferedlanguage}
            label="Language" //
            onChange={preflanguage_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          sx={{ m: 1 }}
          style={{ marginTop: 73, width: "110px" }}
          size="small"
        >
          <InputLabel id="demo-select-small">Type</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Usertype"
            onChange={usertype_select_onchange} //
          >
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{ m: 1 }}
          style={{ marginTop: 73, width: "130px" }}
          size="small"
        >
          <InputLabel id="demo-select-small">Module</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={selModuleDetails}
            label="Module"
            onChange={module_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype && usertype != ""
              ? modules.map((option) => (
                  <MenuItem key={option.moduleid} value={option}>
                    {option.modulename}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>

        <FormControl
          sx={{ m: 1 }}
          style={{ marginTop: 73, width: "130px" }}
          size="small"
        >
          <InputLabel id="demo-select-small">Sub-Module</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={selSubModuleDetails}
            label="Submodule"
            onChange={submodule_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype && usertype != ""
              ? subModules.map((option) => (
                  <MenuItem key={option.submoduleid} value={option}>
                    {option.submodulename}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>

        <FormControl
          sx={{ m: 1 }}
          style={{ marginTop: 73, width: "130px" }}
          size="small"
        >
          <InputLabel id="demo-select-small">Topic</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={selTopicDetails} //
            label="Topic"
            onChange={topic_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype && usertype != ""
              ? topics.map((option) => (
                  <MenuItem key={option.topicid} value={option}>
                    {option.topicname}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>

        <Button
          onClick={navigate_to} //
          variant="outlined"
          sx={{ m: 1, minWidth: 120, marginTop: 0 }}
          size="small"
        >
          Add Modules&Submodule
        </Button>
        <Button
          onClick={navigate_too}
          variant="outlined"
          sx={{ m: 1, minWidth: 120, marginTop: 0 }} //
          size="small"
        >
          Assignment
        </Button>
      </div>

      {/* Show List */}
      <div>
        <Button
          onClick={create_content_button_click}
          variant="contained"
          disabled={disable_content_button}
          // disabled={module.length > 0 ? false : true}
        >
          Create New Content
        </Button>

        {contents.length > 0 ? (
          <Button
            style={{ marginRight: 12 }}
            onClick={create_quiz_button_click}
            variant="contained"
            // disabled={disable_content_button}
          >
            Create New Quiz
          </Button>
        ) : null}

        {/* Tabs for Contents and quizs */}

        <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
          <AppBar position="static" style={{ background: "#2E3B55" }}>
            <Tabs
              value={tabIndex}
              onChange={onTabChange}
              indicatorColor="primary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Content" {...a11yProps(0)} />
              <Tab label="Quiz" {...a11yProps(1)} />
              {/* <Tab label="Student Assessment" {...a11yProps(2)} /> */}
            </Tabs>
          </AppBar>
          <div
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={tabIndex}
            onChangeIndex={onTabIndexChange}
          >
            <TabPanel value={tabIndex} index={0} dir={theme.direction}>
              {/* Contents */}
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={3}>
                  {contents.map((eachsegment, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={isSmallScreen ? 12 : 6}
                      md={4}
                      key={index}
                    >
                      <Card sx={{ maxWidth: 345 }}>
                        <CardHeader
                          avatar={
                            <Avatar sx={{ bgcolor: purple[500] }}>
                              <AnalyticsIcon />
                            </Avatar>
                          }
                          action={
                            <>
                              <IconButton
                                id={index + 1.1}
                                onClick={(e) =>
                                  handleVertMenuClick(e, eachsegment, index)
                                }
                                aria-controls={
                                  openVertMenu ? { index } : undefined
                                }
                                aria-expanded={
                                  openVertMenu ? "true" : undefined
                                }
                                aria-haspopup="true"
                              >
                                <MoreVertIcon />
                              </IconButton>
                            </>
                          }
                          title={
                            <div onClick={() => contentOnClick(eachsegment)}>
                              <div
                                style={{
                                  cursor: "pointer",
                                  wordBreak: "break-all",
                                }}
                              >
                                {eachsegment.topicname}
                              </div>
                              <div style={{ color: "grey" }}>
                                {eachsegment.id ? eachsegment.id : ""}
                                <br />
                                {eachsegment.duration
                                  ? eachsegment.duration
                                  : 0}{" "}
                                Minute(s)
                              </div>
                            </div>
                          }
                          // subheader={
                          //   <div
                          //     style={{ cursor: "pointer" }}
                          //     onClick={() => contentOnClick(eachsegment)}
                          //   >
                          //     {eachsegment.contentData ? eachsegment.contentData : ""}
                          //   </div>
                          // }
                        />
                      </Card>
                    </Grid>
                  ))}
                  <Menu
                    id={selectedIndex}
                    anchorEl={anchorEl}
                    open={openVertMenu}
                    onClose={handleVertMenuClose}
                    MenuListProps={{
                      "aria-labelledby": "vert-button",
                    }}
                    PaperProps={{
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: "20ch",
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() =>
                        update_content_button_click(
                          selectedSegment,
                          selectedIndex
                        )
                      }
                    >
                      Edit
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        delete_content_button_click(
                          selectedSegment,
                          selectedIndex
                        )
                      }
                    >
                      Delete
                    </MenuItem>
                  </Menu>
                </Grid>
              </Box>
              {/* Contents ends */}
            </TabPanel>
            <TabPanel value={tabIndex} index={1} dir={theme.direction}>
              {/* Quizs */}
              <Card sx={{ maxWidth: 345 }} style={{ marginTop: 23 }}>
                {quiz.map((eachsegment, i) => (
                  <>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {i + 1} . Question : {eachsegment.question}
                      </Typography>
                      {/* <Typography variant="body2" color="text.secondary">
               Lizards are a widespread group of squamate reptiles, with over
               6,000 species, ranging across all continents except Antarctica
             </Typography> */}
                      <div style={{ display: "flex" }}>
                        <div
                          style={{ cursor: "pointer" }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          A : {eachsegment.A}
                        </div>
                        <div
                          style={{ cursor: "pointer", marginLeft: 81 }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          B : {eachsegment.B}
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div
                          style={{ cursor: "pointer" }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          C : {eachsegment.C}
                        </div>
                        <div
                          style={{ cursor: "pointer", marginLeft: 80 }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          D : {eachsegment.D}
                        </div>
                      </div>
                      <div
                        style={{ cursor: "pointer", marginTop: 24 }}
                        // onClick={() => contentOnClick(eachsegment)}
                      >
                        Ans : {eachsegment.answer ? eachsegment.answer : ""}
                      </div>
                    </CardContent>
                    <CardActions>
                      <Button
                        size="small"
                        onClick={() => update_quiz_button_click(eachsegment)}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        onClick={() => delete_quiz_button_click(eachsegment)}
                      >
                        Delete
                      </Button>
                    </CardActions>
                  </>
                ))}
              </Card>
              {/* quiz end */}
            </TabPanel>
            {/* <TabPanel value={tabIndex} index={2} dir={theme.direction}>
              Student Assessment under progress
            </TabPanel> */}
          </div>
        </Box>

        {/* Tabs for Contents and quizs ends */}
      </div>

      <Modal
        open={showUpdate}
        onClose={handleCloseUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
            <TextField
              id="filled-basic"
              label="Objective Question"
              variant="filled"
              value={quizQuestion}
              onChange={quiz_question_select_onchange}
            />

            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2} style={{ marginTop: 12 }}>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label="Option A"
                    variant="outlined"
                    value={optionA}
                    onChange={quiz_optA_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label="Option B"
                    variant="outlined"
                    value={optionB}
                    onChange={quiz_optB_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label="Option C"
                    variant="outlined"
                    value={optionC}
                    onChange={quiz_optC_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label="Option D"
                    variant="outlined"
                    value={optionD}
                    onChange={quiz_optD_select_onchange}
                  />
                </Grid>
              </Grid>

              <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                <InputLabel id="demo-select-small">Ans:</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  label="Ans"
                  value={quizAns}
                  onChange={quiz_ans_select_onchange}
                >
                  <MenuItem value="">
                    <em>Select Answer</em>
                  </MenuItem>

                  <MenuItem value="A">A</MenuItem>
                  <MenuItem value="B">B</MenuItem>
                  <MenuItem value="C">C</MenuItem>
                  <MenuItem value="D">D</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </FormControl>

          <Button
            variant="outlined"
            style={{ marginLeft: 12 }}
            onClick={handleCloseUpdate}
          >
            Close
          </Button>
          <Button variant="contained" onClick={handleQuizSaveChanges}>
            SAVE
          </Button>
        </Box>
      </Modal>

      {/* Editor */}
      <ContentEditor
        open={openEditor}
        operation={operation}
        contenttitle={contenttitle}
        setContenttitle={setContenttitle}
        contentduration={contentduration}
        setContentduration={setContentduration}
        content={content}
        setContent={setContent}
        index={index}
        onSave={saveEditorContentData}
        onClose={handleCloseEditor}
      />

      {/* Preview */}
      <ContentPreview
        open={openPreview}
        contenttitle={previewContenttitle}
        content={previewContent}
        onClose={handleClosePreview}
      />

      {/* Loader */}
      {/* <MuiLoader open={loading} /> */}

      {/* Toaster */}
      <ToastContainer />
    </>
  );
}

export default PptActivityPage;

const language_select_option_list = [
  { value: "od", text: "ଓଡିଆ" },
  { value: "en", text: "English" },
];

const usertype_select_option_list = [
  { value: "fellow", text: "fellow" },
  { value: "Anganwadi", text: "Anganwadi" },
  { value: "school", text: "School" },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
